import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import LazyImage from '../Atoms/LazyImage.js';
import Typography from '../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';
import Button from '../Atoms/Button.js';
import ItemPlaceHolder from "../assets/item-card-placeholder-0f7c213a.jpg";

function AboutUsThree(_a) {
    var classes = _a.classes, _b = _a.firstImage, firstImage = _b === void 0 ? ItemPlaceHolder : _b, _c = _a.secondImage, secondImage = _c === void 0 ? ItemPlaceHolder : _c, description = _a.description, onKnowMoreClick = _a.onKnowMoreClick, imageComponent = _a.imageComponent;
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: classNames('about-us-three', classes) },
        React__default.createElement("div", { className: "about-us-three__left" },
            React__default.createElement(LazyImage, { src: firstImage, alt: "About Us Image", classes: "about-us-three__first-image", imageComponent: imageComponent }),
            React__default.createElement(LazyImage, { src: secondImage, alt: "About Us Image", classes: "about-us-three__second-image", imageComponent: imageComponent })),
        React__default.createElement("div", { className: "about-us-three__right" },
            React__default.createElement(Typography, { classes: "about-us-three__title", variant: 'displayText' }, t('landingScreen.aboutUs')),
            React__default.createElement(Typography, { classes: "about-us-three__description", variant: 'bodyTextOne' }, description),
            React__default.createElement(Button, { classes: "about-us-three__button--mobile", onClick: onKnowMoreClick, variant: 'link', size: 'md' }, t('landingScreen.knowMore')),
            React__default.createElement(Button, { classes: "about-us-three__button--desktop", onClick: onKnowMoreClick, variant: 'solid', size: 'md' }, t('landingScreen.knowMore')))));
}

export { AboutUsThree as default };
//# sourceMappingURL=AboutUsThree.js.map
